


































import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { mdiStar } from '@mdi/js'
import { declension } from '~/assets/functions/declension'
import { filterLinkToProductReviews } from '~/assets/filters/produts'
import { IStyle } from '~/assets/interfaces/classes'
import ComponentIcon from '~/components/icon/icon.vue'

@Component({
  components: {
    ComponentIcon,
  },
  filters: {
    filterLinkToProductReviews,
  },
})
export default class ComponentRating extends Vue {
  @Prop({ type: [String, Number], default: 0 }) private reviews!:
    | number
    | string

  @Prop({
    type: Boolean,
    default: false,
  })
  private multiline!: boolean

  @Prop({
    type: String,
    default: '',
  })
  private to!: string

  @Prop({ type: [String, Number], default: 0 }) private rating!: number | string

  private icons = {
    mdiStar,
  }

  private get reviewsRender() {
    return (
      this.reviews.toString() +
      ' ' +
      declension(Number(this.reviews), ['отзыв', 'отзыва', 'отзывов'])
    )
  }

  private get isEmpty() {
    return Number(this.reviews) === 0
  }

  private get ratingRender() {
    return this.rating.toString()
  }

  private $style!: IStyle

  private get classReviews() {
    return {
      [this.$style.reviews]: true,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
      [this.$style.multiline]: this.multiline,
    }
  }

  private get classRating() {
    return {
      [this.$style.rating]: true,
      [this.$style.multiline]: this.multiline,
    }
  }
}
